import { IconBaseType } from "@/v2-components/core/icon/type";
import { cn } from "@/libs/utils";
import { useId } from "react";

/**
 * 색상을 바꿀 수 없습니다.
 */
export default function MetaColoredIcon({ className }: IconBaseType) {
  const id = useId();
  const id2 = useId();

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
    >
      <path
        d="M3.7704 14.2296C3.7704 15.0342 3.94692 15.6519 4.17782 16.0256C4.48047 16.5151 4.93185 16.7228 5.39206 16.7228C5.98554 16.7228 6.52853 16.5755 7.57489 15.1283C8.41339 13.9683 9.40097 12.3401 10.0656 11.3194L11.1911 9.59003C11.973 8.38904 12.8779 7.05397 13.9155 6.14901C14.7629 5.41034 15.6764 5 16.596 5C18.14 5 19.6106 5.89472 20.7362 7.57278C21.968 9.41051 22.5658 11.7254 22.5658 14.1141C22.5658 15.5343 22.286 16.5777 21.8096 17.4021C21.3495 18.1993 20.4526 18.9959 18.9438 18.9959V16.7225C20.2357 16.7225 20.558 15.5353 20.558 14.1768C20.558 12.2408 20.1067 10.0924 19.1123 8.55727C18.4067 7.46837 17.4922 6.80304 16.4861 6.80304C15.3979 6.80304 14.5223 7.62388 13.5381 9.08702C13.0149 9.86453 12.4778 10.8119 11.8747 11.8811L11.2108 13.0572C9.87732 15.4222 9.53945 15.9606 8.87262 16.8492C7.70393 18.4055 6.70585 18.9955 5.39206 18.9955C3.83342 18.9955 2.84787 18.3206 2.23744 17.3035C1.7392 16.4748 1.49445 15.3873 1.49445 14.1483L3.7704 14.2296Z"
        fill="#0081FB"
      />
      <path
        d="M3.28894 7.73324C4.33239 6.12482 5.83824 5 7.56538 5C8.56557 5 9.56012 5.29603 10.5983 6.14389C11.734 7.07065 12.9446 8.5976 14.4548 11.1131L14.9963 12.0156C16.3036 14.1934 17.0473 15.3138 17.4826 15.8421C18.0424 16.5206 18.4344 16.7229 18.9437 16.7229C20.2356 16.7229 20.558 15.5358 20.558 14.1772L22.5658 14.1142C22.5658 15.5344 22.2859 16.5778 21.8095 17.4022C21.3494 18.1994 20.4525 18.996 18.9437 18.996C18.0058 18.996 17.1748 18.7923 16.2559 17.9253C15.5498 17.26 14.7237 16.0781 14.0884 15.0156L12.1986 11.8588C11.2504 10.2746 10.3804 9.09338 9.87725 8.55841C9.33567 7.98312 8.63954 7.28849 7.52866 7.28849C6.62961 7.28849 5.86605 7.91939 5.22711 8.88446L3.28894 7.73324Z"
        fill={`url(#${id})`}
      />
      <path
        d="M7.52873 7.28849C6.62968 7.28849 5.86612 7.91939 5.22718 8.88446C4.32363 10.2481 3.77084 12.2793 3.77084 14.2299C3.77084 15.0345 3.94737 15.6522 4.17826 16.0259L2.23744 17.3039C1.7392 16.4752 1.49445 15.3877 1.49445 14.1486C1.49445 11.8954 2.11291 9.54687 3.28901 7.73324C4.33246 6.12482 5.83831 5 7.56545 5L7.52873 7.28849Z"
        fill={`url(#${id2})`}
      />
      <defs>
        <linearGradient
          id={id}
          x1="5.55755"
          y1="16.9023"
          x2="20.0038"
          y2="18.2864"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0064E1" />
          <stop offset="0.4" stopColor="#0064E1" />
          <stop offset="0.83" stopColor="#0073EE" />
          <stop offset="1" stopColor="#0082FB" />
        </linearGradient>
        <linearGradient
          id={id2}
          x1="5.8496"
          y1="15.1855"
          x2="5.8496"
          y2="9.83629"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0082FB" />
          <stop offset="1" stopColor="#0064E0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
